<div class="login-page-container">
  <div class="login-form-container">
    <app-login-form (loggedIn)="onLoggedIn($event)"></app-login-form>
  </div>
  <div class="w-100 login-picture"></div>
</div>
